@if (qrCodeWidget.url) {
  <div class="qr-code-widget" [style.background-color]="backgroundColor">
    <div #qrCodeBody class="qr-code-widget-body">
      <qrcode
        class="qr-code-widget-image"
        [qrdata]="qrCodeWidget.url"
        [width]="qrCodeSize"
        [colorLight]="colorLight"
      ></qrcode>
    </div>
    @if (!qrCodeWidget.hide_url) {
      <div
        class="qr-code-widget-url"
        [style.color]="textColor"
        [style.font-family]="fontFamily"
        [style.font-size.cqw]="fontSize"
      >
        {{ qrCodeWidget.url }}
      </div>
    }
  </div>
}
